import { Input, Modal, Radio, Table, TableProps } from 'antd';
import { debounce, isEmpty } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { strings } from 'utils/localizedStrings';

export interface ISelectTableList {
  open?: boolean;
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  title?: string;
  productTableProps?: TableProps;
  value?: any,
  onChange?: (value: any) => void;
  onGetList?: (params: any) => Promise<void>;
  allOption?: boolean;
  searchInput?: boolean;
}

const SelectTableList = ({
  open,
  setOpen,
  title,
  productTableProps,
  value,
  onChange,
  onGetList,
  allOption = true,
  searchInput = true,
}: ISelectTableList) => {
  const [search, setSearch] = useState('');
  const debounceSearch = useMemo(
    () =>
      debounce((values: any) => {
        onGetList?.({ page: 0, search: values || undefined });
      }, 600),
    []
  );

  const getRowKey = (record: any) => {
    const rowKey = productTableProps?.rowKey;

    if (!record) return undefined;

    if (typeof rowKey === "function") {
      return rowKey(record);
    }

    if (typeof rowKey === "string") {
      return record?.[rowKey];
    }

    return record?.key;
  };

  useEffect(() => {
    return () => debounceSearch.cancel();
  }, [debounceSearch]);

  return (
    <Modal
      open={open}
      onCancel={() => setOpen?.(false)}
      width={500}
      centered
      styles={{
        body: {
          overflowY: "auto",
          maxHeight: "calc(100vh - 120px)",
          scrollbarWidth: "none",
          overflowX: "hidden",
        },
      }}
      footer={null}
      closeIcon={null}
      title={title}
      destroyOnHidden={true}
    >
      <div className='flex justify-between items-center pb-3'>
        {allOption && <Radio
          checked={isEmpty(value)}
          onChange={() => {
            onChange?.(undefined);
            setOpen?.(false);
          }}
        >
          {strings.GlobalLabels.All}
        </Radio>}
        {searchInput && <Input
          className="w-60"
          placeholder={strings.GlobalLabels.Search}
          onChange={(e) => {
            debounceSearch(e.target.value);
            setSearch(e.target.value);
          }}
          allowClear
        />}
      </div>
      <Table
        {...productTableProps}
        pagination={{
          position: ["bottomCenter"],
          showSizeChanger: false,
          simple: true,
          ...productTableProps?.pagination,
          onChange(page) {
            onGetList?.({ page: page - 1, search: search || undefined });
          },
        }}
        scroll={productTableProps?.scroll}
        rowSelection={{
          type: "radio",
          selectedRowKeys: value ? [getRowKey(value)] : [],
          onSelect: (record) => {
            onChange?.(record);
            setOpen?.(false);
          },
        }}
        onRow={(record) => ({
          onClick: () => {
            productTableProps?.onRow?.(record);
            onChange?.(record);
            setOpen?.(false);
          },
        })}
      />
    </Modal>
  )
}

export default SelectTableList